export const QK_TAG_TYPES = '/tag-types/all';
export const QK_MEASURES = '/measures';
export const QK_CRITERIA_TYPES = '/criteria-types';
